import React, { memo } from 'react';

const RichText = memo(({ className = '', content, tagName = 'article', ...props }) => {
    const Component = tagName;
    const attributes = {
        className: ['prose lg:prose-lg font-sans text-current', className].join(' '),
        ...props,
    };
    return typeof content === 'string' ? (React.createElement(Component, { suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: content }, ...attributes })) : (React.createElement(Component, { ...attributes, suppressHydrationWarning: true }, content));
});

export { RichText };
//# sourceMappingURL=RichText.js.map
